<template>
<div id="sendEmailTransfer">
    <div class="tab-transfer">{{$t('language.popup.chooseAction')}}</div>
    <cloud-select ref="cloudSelect" :widthVal="400" @changeOption="onChangeOption" :selectOption="selectOption" :placeholder="placeholderValue" style="margin-bottom: 40px;"></cloud-select>
    <div class="check-item-positions">
        <div class="icon-util" style="float:left" :class="[isSaveAtt?'check-small':'nocheck-small-blue']" @click="isSaveAtt=!isSaveAtt"></div>
        <div class="check-item-position"><span>{{$t('language.emailTransfer.saveAtt')}}</span></div>
    </div>
    <div class="check-item-positions">
        <div class="icon-util" style="float:left" :class="[isConver?'check-small':'nocheck-small-blue']" @click="isConver=!isConver"></div>
        <div class="check-item-position">
            <span>{{$t('language.emailTransfer.converFormat')}}</span>
            <div class="icon-util question-mark">
                <div class="plan-questionTxt">{{$t('language.emailTransfer.converFormatTip')}}</div>
            </div>
        </div>
    </div>
    <div class="check-item-positions">
        <div class="icon-util" style="float:left" :class="[isSaveOnly?'check-small':'nocheck-small-blue']" @click="isSaveOnly=!isSaveOnly"></div>
        <div class="check-item-position"><span>{{$t('language.emailTransfer.saveOnly')}}</span></div>
    </div>
    <div class="check-item-positions">
        <div class="icon-util" style="float:left" :class="[isChar==1?'check-small':'nocheck-small-blue']" @click="isChar==1?isChar=0:isChar=1"></div>
        <div class="check-item-position">
            <span>{{$t('language.popup.automaRename')}}</span>
            <div class="icon-util question-mark">
                <div class="plan-questionTxt">{{$t('language.popup.optionsPrompt')}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import cloudSelect from "@/components/common/select/cloud_select";
export default {
    components: {
        "cloud-select": cloudSelect
    },
    data: function () {
        return {
            isSaveAtt: true,
            isConver: true,
            isSaveOnly: false,
            isChar: 1,
            replace: 4,
            selectOption: [
                {
                    name: this.$t('language.popup.overWriteSourceNewer')
                },
                {
                    name: this.$t('language.popup.skipEmail')
                }
            ],
            placeholderValue: this.$t('language.popup.overWriteSourceNewer'),
        }
    },
    methods: {
        init() {
            this.isSaveAtt = true;
            this.isConver = true;
            this.isSaveOnly = false;
            this.isChar = 1;
            this.replace = 4;
            this.$refs.cloudSelect.currentValue = this.selectOption[0].name;
            this.$refs.cloudSelect.selectShowFunction();
        },
        onChangeOption(newValue) {
            switch (newValue.replace(/^\s+|\s+$/g, "")) {
                case this.$t('language.popup.skipEmail').replace(/^\s+|\s+$/g, ""):
                    this.replace = 2;
                    break;
                case this.$t('language.popup.overWriteSourceNewer').replace(/^\s+|\s+$/g, ""):
                    this.replace = 4;
                    break;
            }
        }
    }

};
</script>

<style scoped>
#sendEmailTransfer {
    display: flex;
    flex-direction: column;
}

.icon-util {
    margin-top: 2px;/*no*/
    cursor: pointer;
}

.check-item-positions {
    margin-bottom: 10px;/*no*/
}

.check-item-position {
    position: unset;
    float:left;
    line-height: 20px;/*no*/
    margin-left: 5px;/*no*/
    max-width: calc(100% - 20px);/*no*/
}

.question-mark{
  margin: 0 !important;
  position: relative;
  top: 0px;/*no*/
  left: 5px;/*no*/
  vertical-align:middle
}

.question-mark:hover .plan-questionTxt {
  display: block;
}

.plan-questionTxt {
  text-align: left;
  display: none;
  position: absolute;
  width: 255Px;/*no*/
  border: 1Px solid #5562b4;/*no*/
  border-radius: 3Px;/*no*/
  left: 10Px !important;/*no*/
  top: 18Px !important;/*no*/
  background: #fff;
  z-index: 3;
  font-size: 12Px;/*no*/
  box-sizing: border-box;
  padding: 5Px;/*no*/
  line-height: 20Px;/*no*/
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_email_transfer.vue